import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faGear,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";
import swal from "sweetalert";

import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../index.css";

// const pageStyles = `
//   @keyframes matpelShimmer {
//     0% {
//       background-position: -468px 0;
//     }

//     100% {
//       background-position: 468px 0;
//     }
//   }

//   .matpel-shimmer {
//     animation: matpelShimmer 1.2s linear infinite;
//     background: linear-gradient(
//       to right,
//       #ddeaff 8%,
//       #f4f8ff 18%,
//       #ddeaff 33%
//     );
//     background-size: 800px 104px;
//   }

//   .matpel-header-actions {
//     display: flex;
//     align-items: center;
//     justify-content: flex-end;
//     gap: 8px;
//     flex-wrap: wrap;
//   }

//   .matpel-nav-button {
//     display: inline-flex;
//     min-height: 38px;
//     align-items: center;
//     justify-content: center;
//     padding: 8px 14px;
//     border: 1px solid #dfe5f2;
//     border-radius: 10px;
//     background: #ffffff;
//     color: #42506b;
//     font-size: 12.5px;
//     font-weight: 700;
//     text-decoration: none;
//     transition:
//       border-color 0.2s ease,
//       color 0.2s ease,
//       background 0.2s ease;
//   }

//   .matpel-nav-button:hover {
//     border-color: #7892ff;
//     background: #f7f9ff;
//     color: #315fc5;
//     text-decoration: none;
//   }

//   .matpel-toolbar-card {
//     display: flex;
//     width: 100%;
//     align-items: flex-end;
//     justify-content: space-between;
//     gap: 16px;
//     margin-bottom: 18px;
//     padding: 18px;
//     border: 1px solid #e5eaf4;
//     border-radius: 16px;
//     background: #ffffff;
//   }

//   .matpel-filter-side {
//     display: flex;
//     min-width: 0;
//     flex: 1;
//     align-items: flex-end;
//     gap: 12px;
//   }

//   .matpel-filter-field {
//     width: min(100%, 310px);
//     min-width: 220px;
//   }

//   .matpel-filter-label {
//     display: block;
//     margin-bottom: 7px;
//     color: #17213d;
//     font-size: 12.5px;
//     font-weight: 700;
//   }

//   .matpel-filter-select {
//     width: 100%;
//     height: 40px;
//     padding: 0 38px 0 13px;
//     border: 1px solid #dce3ef;
//     border-radius: 10px;
//     outline: none;
//     background: #ffffff;
//     color: #27324f;
//     font-size: 13px;
//     transition:
//       border-color 0.2s ease,
//       box-shadow 0.2s ease;
//   }

//   .matpel-filter-select:focus {
//     border-color: #7892ff;
//     box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08);
//   }

//   .matpel-filter-button {
//     display: inline-flex;
//     height: 40px;
//     align-items: center;
//     justify-content: center;
//     padding: 0 18px;
//     border: 0;
//     border-radius: 10px;
//     // background: #3f5bea;
//     background: #f4aa33;
//     color: #ffffff;
//     font-size: 13px;
//     font-weight: 700;
//     box-shadow: 0 7px 16px rgba(63, 91, 234, 0.18);
//     transition:
//       transform 0.2s ease,
//       opacity 0.2s ease;
//   }

//   .matpel-filter-button:hover:not(:disabled) {
//     transform: translateY(-1px);
//   }

//   .matpel-filter-button:disabled {
//     cursor: not-allowed;
//     background: #c9cfdd;
//     box-shadow: none;
//   }

//   .matpel-toolbar-actions {
//     display: flex;
//     align-items: center;
//     justify-content: flex-end;
//     gap: 9px;
//     flex-wrap: wrap;
//   }

//   .matpel-config-button {
//     display: inline-flex;
//     min-height: 42px;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//     padding: 9px 14px;
//     border: 1px solid #dce3ef;
//     border-radius: 10px;
//     background: #ffffff;
//     color: #3d4a66;
//     font-size: 12.5px;
//     font-weight: 700;
//     text-decoration: none;
//     transition:
//       background 0.2s ease,
//       border-color 0.2s ease,
//       color 0.2s ease;
//   }

//   .matpel-config-button:hover {
//     border-color: #7892ff;
//     background: #f7f9ff;
//     color: #315fc5;
//     text-decoration: none;
//   }

//   .matpel-skeleton-select {
//     width: 280px;
//     height: 44px;
//     border-radius: 10px;
//   }

//   .matpel-skeleton-button {
//     width: 96px;
//     height: 44px;
//     border-radius: 10px;
//   }

//   .matpel-search-wrap {
//     margin-bottom: 14px;
//   }

//   .matpel-table {
//     min-width: 680px;
//   }

//   .matpel-col-name {
//     width: auto;
//   }

//   .matpel-type-badge {
//     display: inline-flex;
//     min-height: 28px;
//     align-items: center;
//     justify-content: center;
//     padding: 4px 10px;
//     border-radius: 999px;
//     background: #eef3ff;
//     color: #315fc5;
//     font-size: 11px;
//     font-weight: 700;
//     white-space: nowrap;
//   }

//   .matpel-type-badge.kokurikuler {
//     background: #fff4e8;
//     color: #b96a13;
//   }

//   @media (max-width: 900px) {
//     .matpel-toolbar-card {
//       align-items: stretch;
//       flex-direction: column;
//     }

//     .matpel-toolbar-actions {
//       justify-content: flex-start;
//     }
//   }

//   @media (max-width: 780px) {
//     .matpel-header-actions {
//       width: 100%;
//       justify-content: flex-start;
//       margin-top: 12px;
//     }

//     .matpel-nav-button {
//       flex: 1;
//       min-width: 120px;
//     }

//     .matpel-toolbar-card {
//       gap: 14px;
//       padding: 15px;
//       border-radius: 13px;
//     }

//     .matpel-filter-side {
//       width: 100%;
//       align-items: stretch;
//       flex-direction: column;
//     }

//     .matpel-filter-field {
//       width: 100%;
//       min-width: 0;
//     }

//     .matpel-filter-button,
//     .matpel-toolbar-actions,
//     .matpel-config-button,
//     .matpel-toolbar-actions .btn-create {
//       width: 100%;
//     }

//     .matpel-toolbar-actions {
//       align-items: stretch;
//       flex-direction: column;
//     }

//     .matpel-table {
//       min-width: 640px;
//     }
//   }
// `;

export default function DataMatpel() {
  document.title = "Data Mata Pelajaran";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level");

  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [branches, setBranches] = useState([]);
  const [data, setData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [formFilter, setFormFilter] = useState({
    ysb_branch_id: "",
  });

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const firstLoadDone = useRef(false);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  useEffect(() => {
    const rolePermissions =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }

    const foundPermission = rolePermissions.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate, storageLevel]);

  const fetchBranches = useCallback(async () => {
    setLoading(true);

    try {
      const response = await APIMS.get(
        "/api/access/branches?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      const branchData = response?.data?.data || [];

      setBranches(branchData);

      if (branchData.length > 0) {
        setFormFilter((previous) => ({
          ...previous,
          ysb_branch_id:
            previous.ysb_branch_id || branchData[0]?.branch_code || "",
        }));
      }
    } catch (error) {
      setBranches([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data cabang",
      });
    } finally {
      setLoading(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    fetchBranches();
  }, [fetchBranches]);

  const GetResponseData = useCallback(async () => {
    if (!formFilter.ysb_branch_id) {
      return;
    }

    setIsFetching(true);

    try {
      const response = await APISD.get(
        `/api/matpels?page=1&limit=1000&ascending=1&search=&ysb_branch_id=${formFilter.ysb_branch_id}`,
        fetchParams
      );

      setData(response?.data?.data || []);
      setHasSearched(true);
    } catch (error) {
      setData([]);
      setHasSearched(true);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data mata pelajaran",
      });
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams, formFilter.ysb_branch_id]);

  useEffect(() => {
    if (firstLoadDone.current || !formFilter.ysb_branch_id) {
      return;
    }

    firstLoadDone.current = true;
    GetResponseData();
  }, [formFilter.ysb_branch_id, GetResponseData]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    setFormFilter((previous) => ({
      ...previous,
      [name]: value,
    }));

    setHasSearched(false);
  };

  const handleCari = async () => {
    if (!formFilter.ysb_branch_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Silakan pilih cabang terlebih dahulu.",
        icon: "warning",
      });

      return;
    }

    setSearchKeyword("");
    setData([]);
    setHasSearched(false);

    await GetResponseData();
  };

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const query = searchKeyword.trim().toLowerCase();
    const source = Array.isArray(data) ? data : [];

    const filtered = query
      ? source.filter((item) =>
          String(item?.name_matpel || "")
            .toLowerCase()
            .includes(query)
        )
      : source;

    return [...filtered].sort((first, second) =>
      nameCollator.compare(
        String(first?.name_matpel || "").trim(),
        String(second?.name_matpel || "").trim()
      )
    );
  }, [data, nameCollator, searchKeyword]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));

    return pages <= 0 ? 1 : pages;
  }, [rowsPerPage, totalRows]);

  useEffect(() => {
    setTablePage(1);
  }, [data, searchKeyword]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;

    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (
        let pageNumber = 1;
        pageNumber <= totalPages;
        pageNumber += 1
      ) {
        pages.push(pageNumber);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (
      let pageNumber = left;
      pageNumber <= right;
      pageNumber += 1
    ) {
      if (pageNumber !== 1 && pageNumber !== totalPages) {
        pages.push(pageNumber);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const destination = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(destination);
  };

  const deleteById = (id) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),

      preConfirm: async () => {
        try {
          const response = await APISD.delete(
            `/api/matpels/${id}`,
            fetchParams
          );

          if (response?.data?.error) {
            throw new Error(response?.data?.message);
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error?.response?.data?.message ||
              error?.message ||
              "Gagal menghapus data"
          );

          return false;
        }
      },
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      ToastSuccess.fire({
        icon: "success",
        title: "Data berhasil dihapus",
      });

      GetResponseData();
    });
  };

  const openUpdateModal = (item) => {
    setSelectedId(item?.id);
    setSelectedData(item);
    setModalUpdate(true);
  };

  const getMatpelType = (value) => {
    return Number(value) === 1
      ? "Kokurikuler"
      : "Intrakurikuler";
  };

  return (
    <div className="body sims-page">
      {/* <style>{pageStyles}</style> */}

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          filterData={formFilter}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={selectedId}
          dataUpdate={selectedData}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faBookOpen} />
            </span>

            <h4 className="page-title-text">
              Data Mata Pelajaran
            </h4>
          </div>

          <div className="ml-auto menu-navigation-wrapper">
            <Link
              to="/matpels/fase"
              className="menu-navigation-button"
            >
              Fase
            </Link>

            <Link
              to="/matpels/tipe-ujian"
              className="menu-navigation-button"
            >
              Tipe Ujian
            </Link>

            <Link
              to="/matpels/config-matpels"
              className="menu-navigation-button"
            >
              <FontAwesomeIcon icon={faGear} /> Konfigurasi Mapel
            </Link>

          </div>
        </div>
      </div>

      <div className="body-content sims-content">
        <div className="single-toolbar-card">
          <div className="single-filter-side">
            {loading ? (
              <>
                <div className="shimmer single-skeleton-select" />
                <div className="shimmer single-skeleton-button" />
              </>
              ) : (
              <>
                <div className="sims-filter-field">
                  <label
                    className="sims-filter-label"
                    htmlFor="filter-branch"
                  >
                    Cabang
                  </label>

                  <select
                    id="filter-branch"
                    className="sims-filter-select"
                    name="ysb_branch_id"
                    value={formFilter.ysb_branch_id}
                    onChange={handleFilterChange}
                  >
                    <option value="" disabled>
                      Pilih Cabang
                    </option>

                    {branches.map((branch, index) => (
                      <option
                        key={branch?.branch_code || index}
                        value={branch?.branch_code}
                      >
                        {branch?.branch_name}
                      </option>
                    ))}
                  </select>
                </div>

                <button
                  type="button"
                  className="single-filter-button"
                  onClick={handleCari}
                  disabled={
                    !formFilter.ysb_branch_id ||
                    isFetching
                  }
                >
                  Tampilkan Data
                </button>
              </>
            )}
          </div>

          <div className="sims-toolbar-actions">
            {Number(permission.create) === 1 && (
              <button
                type="button"
                className="btn btn-create sims-header-button"
                onClick={() => setModalAdd(true)}
              >
                <FontAwesomeIcon icon={faPlus} />

                <span>Tambah Mata Pelajaran</span>
              </button>
            )}

          </div>
        </div>

        {isFetching && (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12}/>
          </div>
        )}

        {hasSearched && !isFetching && (
          <>
            <div className="sims-search-wrap mb-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="sims-search-icon"
              />

              <input
                type="text"
                className="sims-search-input"
                placeholder="Cari mata pelajaran..."
                value={searchKeyword}
                onChange={(event) =>
                  setSearchKeyword(event.target.value)
                }
              />
            </div>

            <div className="sims-table-card">
              <div className="sims-table-scroll">
                <table className="sims-table">
                  <thead>
                    <tr>
                      <th className="sims-col-number">
                        No
                      </th>

                      <th>
                        Mata Pelajaran
                      </th>

                      <th>Tipe</th>

                      <th className="sims-col-action">
                        Aksi
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td
                          colSpan={4}
                          className="sims-empty-state"
                        >
                          <div className="sims-empty-state-content">
                            Data mata pelajaran tidak
                            ditemukan
                          </div>
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map(
                        (item, index) => (
                          <tr
                            key={
                              item?.id ||
                              `matpel-${index}`
                            }
                          >
                            <td className="sims-col-number">
                              <span className="sims-number-badge">
                                {(tablePage - 1) *
                                  rowsPerPage +
                                  index +
                                  1}
                              </span>
                            </td>

                            <td>
                              <span className="sims-text-bold">
                                {item?.name_matpel ||
                                  "-"}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`sims-type-badge ${
                                  Number(
                                    item?.matpel_type
                                  ) === 1
                                    ? "kokurikuler"
                                    : ""
                                }`}
                              >
                                {getMatpelType(
                                  item?.matpel_type
                                )}
                              </span>
                            </td>

                            <td className="sims-col-action">
                              <div className="sims-action-wrap">
                                {Number(
                                  permission.update
                                ) === 1 && (
                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-edit"
                                    title="Ubah mata pelajaran"
                                    aria-label="Ubah mata pelajaran"
                                    onClick={() =>
                                      openUpdateModal(
                                        item
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        faPenToSquare
                                      }
                                    />
                                  </button>
                                )}

                                {Number(
                                  permission.delete
                                ) === 1 && (
                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-delete"
                                    title="Hapus mata pelajaran"
                                    aria-label="Hapus mata pelajaran"
                                    onClick={() =>
                                      deleteById(
                                        item?.id
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrash}
                                    />
                                  </button>
                                )}

                                {Number(
                                  permission.update
                                ) !== 1 &&
                                  Number(
                                    permission.delete
                                  ) !== 1 && (
                                    <span className="sims-muted-text">
                                      -
                                    </span>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    )}
                  </tbody>
                </table>
              </div>

              {filteredData.length > 0 && (
                <div className="sims-pagination">
                  <div className="sims-pagination-left">
                    <span className="sims-page-info">
                      Menampilkan{" "}
                      <b>
                        {Math.min(
                          (tablePage - 1) *
                            rowsPerPage +
                            1,
                          totalRows
                        )}
                      </b>
                      -
                      <b>
                        {Math.min(
                          tablePage * rowsPerPage,
                          totalRows
                        )}
                      </b>{" "}
                      dari <b>{totalRows}</b> data
                    </span>

                    <select
                      className="sims-page-size"
                      value={rowsPerPage}
                      onChange={(event) => {
                        const value =
                          Number(
                            event.target.value
                          ) || 10;

                        setRowsPerPage(value);
                        setTablePage(1);
                      }}
                    >
                      <option value={10}>
                        10 data / halaman
                      </option>

                      <option value={25}>
                        25 data / halaman
                      </option>

                      <option value={50}>
                        50 data / halaman
                      </option>

                      <option value={100}>
                        100 data / halaman
                      </option>
                    </select>
                  </div>

                  <div className="sims-pagination-right">
                    <button
                      type="button"
                      className="sims-page-nav"
                      onClick={() =>
                        goToPage(tablePage - 1)
                      }
                      disabled={tablePage <= 1}
                    >
                      Sebelumnya
                    </button>

                    <div className="sims-page-numbers">
                      {pageNumbers.map(
                        (pageNumber, index) =>
                          pageNumber === "..." ? (
                            <span
                              key={`dots-${index}`}
                              className="sims-page-dots"
                            >
                              ...
                            </span>
                          ) : (
                            <button
                              type="button"
                              key={`page-${pageNumber}`}
                              className={`sims-page-number ${
                                pageNumber ===
                                tablePage
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() =>
                                goToPage(
                                  pageNumber
                                )
                              }
                            >
                              {pageNumber}
                            </button>
                          )
                      )}
                    </div>

                    <button
                      type="button"
                      className="sims-page-nav"
                      onClick={() =>
                        goToPage(tablePage + 1)
                      }
                      disabled={
                        tablePage >= totalPages
                      }
                    >
                      Selanjutnya
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}